import {useQuery} from "@tanstack/react-query";
import * as _a from "@/lib/api";

export const useFeatures = () => {
  return useQuery({
    queryKey: ['features'],
    queryFn: () => _a.features()
  });
}